import { createActionGroup, emptyProps, props } from '@ngrx/store'

import { TemplateConfigInterface } from '@flowx/shared/interfaces'

import {
  DataModelDraft,
  DocumentContextReference,
  SendFeedbackPayload,
} from '../../../types/ai.types'

const errorProps = props<{ statusCode: number; errorMsg?: any }>

export const AiDesignerActions = createActionGroup({
  source: 'AiDesigner',
  events: {
    uiDesignerNodeAiClick: props<{
      userTaskNavigationAreaId: number
      selectedTemplateConfigId: number
    }>(),

    generateUiFromDocument: props<{ documentContextReference: DocumentContextReference }>(),
    generateUiFromImages: props<{
      imageFiles: File[]
      prompt: string
    }>(),
    generateUiFromNodeAction: emptyProps(),
    aiGenerateInNodeClicked: props<{ templateConfig: TemplateConfigInterface }>(),

    mapTemplateConfigComponentsToDataModel: props<{ templateConfig: TemplateConfigInterface[] }>(),
    mapAiLinkingsToTemplateConfig: props<{
      templateConfig: TemplateConfigInterface[]
    }>(),
    mapTemplateConfigComponentsToAiLinkings: props<{
      templateConfig: TemplateConfigInterface[]
    }>(),
    updateDataModelOnLastMessage: props<{ dataModel: DataModelDraft }>(),
    keepDataModelDraft: emptyProps(),
    saveDataModelDraft: emptyProps(),
    saveDataModelDraftSuccess: emptyProps(),
    saveDataModelDraftFailure: errorProps(),
    reloadDataModel: emptyProps(),
    reloadDataModelSuccess: emptyProps(),
    linkTemplateConfigKeys: emptyProps(),
    linkTemplateConfigKeysSuccess: emptyProps(),
    linkTemplateConfigKeysFailure: errorProps(),
    keepDataModelDraftSuccess: emptyProps(),
    discardTemplateConfigDraft: emptyProps(),
    discardDataModelDraft: emptyProps(),
    discardDataModelDraftSuccess: emptyProps(),

    keepOutcome: emptyProps(),
    keepOutcomeSuccess: emptyProps(),
    discardOutcome: emptyProps(),
    discardOutcomeSuccess: emptyProps(),

    sendFeedback: props<{ payload: SendFeedbackPayload }>(),
  },
})
